import { DateTime } from 'luxon';
export var useDaysWithMissedPunch = function (_a) {
    var punchesTimeSegments = _a.punchesTimeSegments;
    return ((punchesTimeSegments === null || punchesTimeSegments === void 0 ? void 0 : punchesTimeSegments.filter(function (punch) { return !punch.startDateTime || !punch.endDateTime; }).map(function (punch) {
        if (punch.startDateTime) {
            return DateTime.fromISO(punch.startDateTime);
        }
        if (punch.endDateTime) {
            return DateTime.fromISO(punch.endDateTime);
        }
        return null;
    }).filter(function (dateTime) { return !!dateTime; })) || []);
};
